export default "__VITE_ASSET__B5m57wFi__"